import { render, staticRenderFns } from "./CampaignCardComponent.vue?vue&type=template&id=089422d4"
import script from "./CampaignCardComponent.vue?vue&type=script&lang=js"
export * from "./CampaignCardComponent.vue?vue&type=script&lang=js"
import style0 from "./CampaignCardComponent.vue?vue&type=style&index=0&id=089422d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports